<template>
  <div class="vipProductList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select width="" placeholder="请选择会员卡状态" size="small" v-model="param.status" class="add-input">
        <el-option
            v-for="item in productOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
          type="primary"
          size="small"
          @click="searchProducts"
          class="add-input"
      >搜索
      </el-button
      >
      <el-button
          type="primary"
          size="small"
          @click="vipOperation('add', tableData)"
          class="add-input"
      >+新增商品
      </el-button
      >
    </div>
    <!--数据表格-->
    <el-table
        :data="tableData"
        style="width: 100%"
        border
        height="700"
        size="small"
        v-loading="loading"
        element-loading-text="拼命加载中"
        @sort-change="handleSortChange"
        element-loading-spinner="el-icon-loading"
    >
      <el-table-column
          prop="productName"
          label="名称"
          align="center"
          width="180"
          fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.productName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="cover"
          label="背景图"
          align="center"
          min-width="180"
      >
        <template slot-scope="scope">
          <img-load
              :key="scope.row.bgImg"
              :src="imgUrl + '/' + scope.row.bgImg"
              :height="'90px'"
          />
          <!-- {{ imgUrl +'/' + scope.row.bgImg }} -->
        </template>
      </el-table-column>
      <el-table-column
          prop="cover"
          label="背景图2"
          align="center"
          min-width="180"
      >
        <template slot-scope="scope">
          <img-load
              :key="scope.row.bgImg2"
              :src="imgUrl + '/' + scope.row.bgImg2"
              :width="'160px'"
          />
        </template>
      </el-table-column>
      <el-table-column
          prop="originalPrice"
          label="原价"
          align="center"
          width="160"
      >
        <template slot-scope="scope">
          <span>￥{{ scope.row.originalPrice / 10 || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="status"
          label="会员卡状态"
          align="center"
          width="160"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status">上架</span>
          <span v-else>下架</span>
        </template>
     </el-table-column>
      <el-table-column
          prop="discountedPrice"
          label="实际支付金额"
          align="center"
          width="160"
      >
        <template slot-scope="scope">
          <span>￥{{ scope.row.discountedPrice / 10 || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="desc"
          label="赠送金币"
          align="center"
          :show-overflow-tooltip="true"
          width="160px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.giveCoin }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="duration"
          label="VIP天数"
          align="center"
          width="150px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.duration || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="vipLevel"
          label="会员等级"
          align="center"
          width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.vipLevel==1">VIP</span>
          <span v-else-if="scope.row.vipLevel==2">SVIP</span>
          <span v-else>未知</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="desc"
          label="楼凤解锁次数"
          align="center"
          :show-overflow-tooltip="true"
          width="160px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.louFengUnlockTimes || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="desc"
          label="楼凤折扣率(%)"
          align="center"
          :show-overflow-tooltip="true"
          width="160px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.louFengDiscount || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="desc"
          label="金币视频免费天数"
          align="center"
          :show-overflow-tooltip="true"
          width="180px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.goldVideoFreeDay || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="productType"
          label="产品类型"
          align="center"
          width="120px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.productType | productTypeList }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="position"
          label="产品位置"
          align="center"
          width="120px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.position || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="unitPriceDisplay"
          label="是否展示单价"
          align="center"
          width="120px"
      >
        <template slot-scope="scope">
          <el-switch v-model="scope.row.unitPriceDisplay" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="isAmountPay"
          label="金币购买"
          align="center"
          width="100"
      >
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isAmountPay" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="180">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.status"
              active-text="上架"
              inactive-text="下架"
              disabled
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="actionDesc"
          label="活动描述"
          align="center"
          :show-overflow-tooltip="true"
          width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.actionDesc || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="privilegeDesc"
          label="特权描述"
          align="center"
          :show-overflow-tooltip="true"
          width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.privilegeDesc || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="showCountdownTime"
          label="新手卡倒计时(单位：小时)"
          align="center"
          width="190"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.showCountdownTime || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="desc"
          label="备注"
          align="center"
          :show-overflow-tooltip="true"
          width="160px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.desc || "暂无备注" }}</span>
        </template>
      </el-table-column>

      <el-table-column
          prop="sort"
          label="排序"
          align="center"
          :show-overflow-tooltip="true"
          width="160px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.sort }}</span>
        </template>
      </el-table-column>

      <el-table-column
          prop="createdAt"
          label="创建时间"
          align="center"
          width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="privilege" label="特权" align="center" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.privilegeStr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="vipOperation('edit', scope.row)"
          ></el-button>
          <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="removeAdmin(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <vip-action
        ref="addVip"
        @handlerProductList="handlerProductList"
    ></vip-action>
  </div>
</template>
<script>
import API from "@/api";
import {sortEscape} from "@/utils/global";
import VipAction from "./components/vipAction";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      tableData: [],
      status: null,
      productOptions: [
        {label: "上架", value: true},
        {label: "下架", value: false},
        {label: "全部", value: null},
      ],
      // VIP商品列表请求参数
      param: {
        key: "",
        value: "",
        status: null,
      },
    };
  },
  components: {
    VipAction,
  },
  created() {
    this.getProductList(this.param);
  },
  methods: {
    // 请求商品列表
    getProductList() {
      this.loading = true;
      API.getPruductList(this.param)
          .then((res) => {
            this.loading = false
            if (res.code === 200 && res.data.length > 0) {
              this.tableData = res.data;
            }
          })
          .catch(() => {
            this.loading = false;
          });
    },
    searchProducts() {
      this.param.value = this.status;
      this.getProductList(this.param);
    },
    getNamesByIdsInOrder(idList, userList) {
      // 创建一个 id 到 name 的映射
      const idToName = {};
      userList.forEach((user) => {
        idToName[user.id] = user.privilegeName;
      });

      // 按 idList 的顺序提取 name
      return idList.map((id) => idToName[id]).join(",");
    },
    // 数据排序
    handleSortChange(column) {
      this.param.value = sortEscape(column.order);
      this.param.key = column.prop;
      this.getProductList(this.param);
    },
    // 删除管理员
    removeAdmin(row) {
      this.$confirm("您确定要删除当前商品吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.getDeleteSection({id: row.id}).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getProductList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    vipOperation(type, data) {
      this.$refs.addVip.open(type, data);
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerProductList() {
      this.getProductList();
    },
  },
};
</script>

<style lang="scss">
.add-input {
  margin-left: 0 !important;
}
.action-bar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.add-input {
  margin-top: 10px;
}
</style>
